import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {EntityData, provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ExtraEntityModel} from "../extra-entity.model";
import {
    ProductLineSearchPageComponent
} from "../../product-line/product-line-search-page/product-line-search-page.component";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {ProductLineData} from "../../product-line/product-line.data";
import {ExtraProductData} from "../extra.data";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-extra-edit-page",
    templateUrl: "./extra-edit-page.component.html",
    providers: [provideEntityModel(ExtraEntityModel)]
})
export class ExtraEditPageComponent extends AbstractEditPage {
    EditMode = EditMode;
    ProductLineSearchPageComponent = ProductLineSearchPageComponent;
    ProductLineEditPageComponent = ProductLineEditPageComponent;

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ExtraEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    totalIncludedChange(): void {
        if (this.model.data.totalIncluded != undefined) {
            this.model.data.displayDefaults = true;
        }
    }

    selectProductLine(productLines: ProductLineData[]): void {
        let first: boolean = true;
        productLines.forEach((productLine) => {
            if (!this.model.data.extraProducts.find((extraProduct) => extraProduct.productLine.sellableId === productLine.sellableId)) {
                const newEntity: ExtraProductData = <ExtraProductData>EntityData.create(ExtraProductData);
                newEntity.productLine.assign(productLine);
                newEntity.price = productLine.price;
                if (first) {
                    this.editGridComponent.addAndEditRow(newEntity);
                    first = false;
                } else {
                    this.editGridComponent.addRow(newEntity);
                }
            }
        });
    }
}
